/**
 * Returns whether advertising pixels (Meta, Pinterest, Outbrain) may load for
 * this request. When the market honours GPC, any active browser signal blocks
 * them; otherwise they always load.
 */
export const shouldAllowAdvertisingPixels = (
    honourGlobalPrivacyControl: boolean,
    globalPrivacyControl: boolean,
): boolean => {
    if (!honourGlobalPrivacyControl) {
        return true;
    }
    return !globalPrivacyControl;
};

/**
 * Reads the HTTP-layer Global Privacy Control signal from incoming request
 * headers (`Sec-GPC: 1`). Used during SSR where `navigator.globalPrivacyControl`
 * is unavailable.
 */
export const readGlobalPrivacyControlHeader = (
    headers: Record<string, string | string[] | undefined>,
): boolean => {
    const raw = headers['sec-gpc'];
    const value = Array.isArray(raw) ? raw[0] : raw;
    return String(value ?? '').trim() === '1';
};
